import { createSlice } from "@reduxjs/toolkit";

// Los parametros del sistema (tabla configuracion). El codigo es la llave con
// la que se guarda cada parametro.
const initialState = {
    defaultEntity: {
        idConfiguracion: 0,
        codigo: "",
        descripcion: "",
        valor: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    entity: {
        idConfiguracion: 0,
        codigo: "",
        descripcion: "",
        valor: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    validationActive: {
        codigo: false,
        valor: false,
    },
    validationMessage: [],
}

export const configuracionSlice = createSlice({
    name: "configuracion",
    initialState,
    reducers: {
        setEntity: (state, action) => {
            state.entity = action.payload;
        },
        setData: (state, action) => {
            var { name, value } = action.payload;

            state.entity[name] = value
            state.validationActive[name] = true
        },
        setValidationMessage: (state, action) => {
            state.validationMessage = action.payload;
        },
        activeValidations: (state, action) => {
            Object.keys(state.validationActive).forEach(function (key) {
                state.validationActive[key] = true;
            })
        },
    },
});

export const { setEntity, setData, setValidationMessage, activeValidations } = configuracionSlice.actions;
export default configuracionSlice.reducer;
